import Vue from 'vue'
import VueCookies from 'vue-cookies'
import App from './components/App.vue'
import store from './store'
Vue.config.productionTip = false

Vue.use(VueCookies)

document.addEventListener('session-complete', () => {
    if (document.getElementById('iteration-messages')) {
        new Vue({
            el: '#iteration-messages',
            components: {
                'iteration-messages' : App
            },
            store: store
        })
    }
})

